import React, { useEffect, useState } from 'react';

import { useWidgetsTheme } from '@src/core/theme';
import { getContrastColorFrom } from '@src/common/colors';

import { MdClose } from 'react-icons/md';
import Confetti from '@src/assets/images/ConfettiMini.svg';

import { CloseButton, Container, Content, DiscountValue, Icon, Message, Wrapper } from './styles';
import { useAppSelector, useTranslate } from '@src/core/hooks';
import { publicApiTokenSelector } from '@src/features/auth';
import * as storage from '@src/common/storage';
import { cartCouponSelector, cartHasPartnershipWithCouponSelector } from '@src/features/cart';
import Modal from '@src/components/ui2/Modal';
import PartnershipModal from './PartnershipModal';

export const planneWidgetPartnershipBannerKey = 'showPartnershipBanner';
export const planneWidgetPartnershipModalKey = 'showPartnershipModal';

const PartnershipBanner = () => {
  const mainColor = useWidgetsTheme('actionColor');
  const textColor = getContrastColorFrom(mainColor);

  const { i18nElement } = useTranslate();

  const publicApiKey = useAppSelector(publicApiTokenSelector);
  const cartHasPartnershipWithCoupon = useAppSelector(cartHasPartnershipWithCouponSelector);
  const cartCoupon = useAppSelector(cartCouponSelector);

  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleCloseBanner = () => {
    setShowBanner(false);

    storage.setValue(publicApiKey, planneWidgetPartnershipBannerKey, 'false');
  };

  const handleCloseModal = () => {
    setShowModal(false);

    storage.setValue(publicApiKey, planneWidgetPartnershipModalKey, 'false');
  };

  const getFormattedCouponValue = () => {
    return cartCoupon?.formattedDiscount ?? '0';
  };

  const getAffiliateName = () => {
    return cartCoupon?.agentName ?? '';
  };

  const getCouponCode = () => {
    return cartCoupon?.code ?? '';
  };

  useEffect(() => {
    const shouldShowBanner =
      cartHasPartnershipWithCoupon && storage.getValue(publicApiKey, planneWidgetPartnershipBannerKey) !== 'false';
    const shouldShowModal =
      cartHasPartnershipWithCoupon && storage.getValue(publicApiKey, planneWidgetPartnershipModalKey) !== 'false';

    setShowBanner(shouldShowBanner);
    setShowModal(shouldShowModal);
  }, [cartHasPartnershipWithCoupon, publicApiKey]);

  if (!showBanner) {
    return null;
  }

  return (
    <>
      <Modal open={showModal} width={452} showCloseButton={false}>
        <PartnershipModal
          couponCode={getCouponCode()}
          discount={getFormattedCouponValue()}
          affiliateName={getAffiliateName()}
          onClose={() => handleCloseModal()}
        />
      </Modal>

      <Wrapper $mainColor={mainColor} $textColor={textColor}>
        <Container>
          <Content>
            <Icon>
              <Confetti />
            </Icon>

            <DiscountValue>
              {i18nElement('partnership_banner_discount', {
                value: getFormattedCouponValue(),
              })}
            </DiscountValue>

            <Message>
              {i18nElement('partnership_banner_message', {
                value: getFormattedCouponValue(),
                affiliateName: getAffiliateName(),
                couponCode: getCouponCode(),
              })}
            </Message>
          </Content>

          <CloseButton type='button' onClick={() => handleCloseBanner()}>
            <MdClose />
          </CloseButton>
        </Container>
      </Wrapper>
    </>
  );
};

export default PartnershipBanner;
